<template>
  <v-container fluid pa-0>
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-col class="py-0">{{ reportName }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-md class="pb-0 px-0">
        <v-layout row wrap>
          <v-flex
            v-for="filter in reportFilters"
            :key="
              filter.filterName && filter.filterName != ''
                ? filter.filterName
                : filter.name
            "
            class="pr-2"
          >
            <dynamic-report-filter
              :report="report"
              :report-filter="filter"
              @valueChanged="filterOnValueChanged($event)"
              @valueRemoved="filterOnValueRemoved($event)"
            ></dynamic-report-filter>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions class="grey lighten-4">
      <v-layout>
        <report-actions
          v-if="reportSelected"
          :report="report"
          :filters="selectedFilters"
          @load-filters="onLoadFilterSet"
        ></report-actions>
      </v-layout>
    </v-card-actions>
    <div v-if="debug">
      <pre>{{ JSON.stringify(reportFilters, null, 4) }}</pre>
      <pre>{{ JSON.stringify(selectedFilters, null, 4) }}</pre>
    </div>
  </v-container>
</template>

<script>
import DynamicReportFilter from "./DynamicReportFilter";
import ReportActions from "./ReportActions";
export default {
  name: "ReportsListFiltersForm",

  components: { DynamicReportFilter, ReportActions },

  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      debug: false,
      reportName: this.report.name,
      reportFilters: this.report.filters
        ? this.report.filters.map((f) => ({ ...f }))
        : [],
      selectedFilters: [],
    };
  },
  methods: {
    filterOnValueChanged(payload) {
      //console.log("filterOnValueChanged", payload);
      if (Array.isArray(payload.data)) {
        //handling array of filters
        for (let filter of payload.data) {
          this.addOrUpdateFilter({ ...filter, filterName: payload.name });
        }
      } else {
        this.addOrUpdateFilter({ ...payload.data, filterName: payload.name });
      }
    },
    addOrUpdateFilter(filter) {
      this.selectedFilters = [
        ...this.selectedFilters.filter((f) => f.name != filter.name),
        filter,
      ];
    },
    filterOnValueRemoved(valueName) {
      this.selectedFilters = [
        ...this.selectedFilters.filter((f) => f.name != valueName),
      ];
    },
    onLoadFilterSet(payload) {
      this.selectedFilters = [...payload];
      this.updateReportFilters();
    },
    updateReportFilters() {
      this.reportFilters = this.reportFilters.map((f) => {
        const fWithValues = this.selectedFilters.filter(
          (sf) => sf.filterName == f.name || sf.filterName == f.filterName
        );
        return fWithValues ? { ...f, value: fWithValues } : f;
      });
    },
  },
  watch: {
    report(r) {
      this.reportName = r.name;
      this.reportFilters = r.filters.map((f) => ({ ...f }));
      this.selectedFilters = [];
    },
  },
  computed: {
    reportSelected() {
      return this.report.name;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/reports/ReportsListFiltersForm.vue